module.exports = __webpack_public_path__ + "img/c65fd26.jpg";